module.exports = __webpack_public_path__ + "static/media/9.9c681248.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/9.jpg
// module id = 104
// module chunks = 0